// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__hgJOJ","content":"styles_content__20J92","selectAll":"styles_selectAll__hSZhI"};